var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart",staticStyle:{"width":"140px","height":"140px"},attrs:{"id":"main"}})
}
var staticRenderFns = []

export { render, staticRenderFns }